export type CommentReply = {
  id: string;
  author: string;
  time: string;
  body: string;
  likes: number;
  avatar: string;
  liked?: boolean;
  /**
   * Written by the reader, so it carries the same edit / delete rights a
   * top-level comment of theirs does.
   *
   * This used to sit on `Comment` alone, so `canModifyComment` — which reads it
   * — returned false for EVERY reply, including the reader's own. QA: "when
   * replying to a comment, i should be able to delete or edit my reply if the
   * publish time is less than 6 hours."
   */
  isOwn?: boolean;
  /**
   * When the comment was last edited, if ever. Kept SEPARATE from `time` so an
   * edit never destroys the original post time — QA: "編輯訊息後，時間戳不應該
   * 被編輯日期時間覆蓋掉吧？ 而且如果有編輯過，最好在後面顯示編輯過的時間".
   */
  editedAt?: string;
};

export type Comment = CommentReply & {
  replies?: CommentReply[];
  isDeleted?: boolean;
};

const AVATARS = [
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
  "/images/article-comments/avatar.png",
];

export const initialComments: Comment[] = [
  /**
   * Two own comments, deliberately on opposite sides of the six-hour
   * edit window: this one still carries 修改/刪除, `c4` (1天前) no longer does.
   * Both states are then visible without having to post a comment first.
   */
  {
    id: "c0",
    author: "陳美玲",
    time: "30分鐘前",
    body: "補充一點：iPhone 的裝置端推論成本其實比外界想像中高，這也是蘋果遲遲未大規模鋪開的原因之一。",
    likes: 6,
    avatar: AVATARS[3],
    isOwn: true,
  },
  {
    id: "c1",
    author: "張小明",
    time: "2小時前",
    body: "這篇文章分析得很透徹，特別是關於AI隱私保護的部分。蘋果在這方面確實比其他公司做得更好。",
    likes: 24,
    avatar: AVATARS[0],
    replies: [
      {
        id: "c1r1",
        author: "李華",
        time: "1小時前",
        body: "同意，蘋果的隱私保護措施確實很到位。",
        likes: 5,
        avatar: AVATARS[1],
      },
    ],
  },
  {
    id: "c2",
    author: "李華",
    time: "5小時前",
    body: "期待WWDC的發布會！希望蘋果能帶來真正實用的AI功能。",
    likes: 15,
    avatar: AVATARS[1],
    liked: true,
  },
  {
    id: "c3",
    author: "王大衛",
    time: "8小時前",
    body: "此評論已被刪除",
    likes: 8,
    avatar: AVATARS[2],
    isDeleted: true,
  },
  {
    id: "c4",
    author: "陳美玲",
    time: "1天前",
    body: "從投資角度看，蘋果的長期前景還是很不錯的。AI功能的加入應該能刺激新一波換機潮。",
    likes: 32,
    avatar: AVATARS[3],
    isOwn: true,
    replies: [
      {
        id: "c4r1",
        author: "林志偉",
        time: "1小時前",
        body: "確實，蘋果的生態系統優勢不容忽視。",
        likes: 3,
        avatar: AVATARS[4],
      },
    ],
  },
  {
    id: "c5",
    author: "林志偉",
    time: "1天前",
    body: "相比Google和微軟，蘋果在AI領域起步較慢。但憑藉其生態系統優勢，後發制人也不是不可能。",
    likes: 19,
    avatar: AVATARS[4],
  },
  {
    id: "c6",
    author: "黃小芬",
    time: "2天前",
    body: "最關心的還是隱私問題。蘋果一直強調設備端處理，這點確實讓人比較放心。",
    likes: 41,
    avatar: AVATARS[5],
    replies: [
      {
        id: "c6r1",
        author: "劉建國",
        time: "1小時前",
        body: "設備端處理確實能有效保護隱私。",
        likes: 2,
        avatar: AVATARS[6],
      },
    ],
  },
  {
    id: "c7",
    author: "劉建國",
    time: "2天前",
    body: "作為開發者，我更關注API的開放程度。希望能有更多自定義和整合的可能性。",
    likes: 12,
    avatar: AVATARS[6],
  },
];
